import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {},
  userToken: '',
  roleId: '',
  roleSettings: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    updateRoleId: (state, action) => {
      state.roleId = action.payload;
    },
    updateRoleSettings: (state, action) => {
      state.roleSettings = action.payload;
    },
    updateUserToken: (state, action) => {
      state.userToken = action.payload;
    },
    clearUserInfo: (state) => {
      state.userToken = initialState.userToken;
      state.userInfo = initialState.userInfo;
    },
  },
});

export const userInfoSelector = (state) => state.auth.userInfo;
export const roleIdSelector = (state) => state.auth.roleId;
export const roleSettingsSelector = (state) => state.auth.roleSettings;
export const userTokenSelector = (state) => state.auth.userToken;

export const {
  updateUserInfo,
  updateRoleId,
  updateRoleSettings,
  updateUserToken,
  clearUserInfo,
} = authSlice.actions;

export const authReducer = authSlice.reducer;
export const authReducerName = authSlice.name;

export default authSlice.reducer;
